//import react section
import React from 'react'
import { useDispatch } from 'react-redux'
import { withRouter } from 'react-router-dom'
/** Material UI imports section */
import {
	Button,
	Chip,
	Divider,
	IconButton,
	List,
	ListItem,
	ListItemText,
	Paper,
	Typography,
	withStyles
} from '@material-ui/core'
import { AddBox, AddCircle, Delete, Public } from '@material-ui/icons'
import { Translate } from 'react-localize-redux'
//import common components

import DataTable from '../../../common/DataTable'
import LoadingPage from '../../../common/LoadingPage'
import GeneralData from './GeneralData'
import HeaderComponent from './HeaderComponent'
import InternationalComponent from './InternationalComponent'
import NationalComponent from './NationalComponent'
import PreviousOriginComponent from './PreviousOriginComponent'
//Import store section
import yourlogohere from '../../../../resources/images/yourlogohere.png'
import { containerOptions } from '../../../../store/helpers/SelectOptions'
import { deleteContainer, deleteMaterial } from '../../../../store/loadAlerts/LoadAlertAction'
import ListDocumentsComponent from './ListDocumentsComponent'

const DesktopView = (props) => {
	const dispatch = useDispatch()
	//array props section
	const { userRolesByCompany } = props

	//functions props section
	const {
		onLateralPanelConfig,
		onUpdateRequest,
		addPreviousOriging,
		updateLoadAlertItemProperty,
		onSendNotificationToSupplier,
		deleteAnnexesFiles
	} = props
	//bool props section
	const {
		canbeUpdateSupplierInternational,
		canbeUpdateSupplierNacional,
		canbeUpdateSupplierPreviousOrigin,
		isLoading,
		canBeEditInternalUserData,
	} = props

	//string props section
	const { supplierLogo, urlImageSupplier, tab, setTab } = props
	//object
	const { params, loadAlert, supplier, previousOriginData, nacionalData, internacionalData } = props

	const onRendercustomCell = (dataSource, item) => {
		switch (dataSource) {
			case '': {
				return (
					<IconButton
						size='small'
						onClick={() => dispatch(deleteMaterial({ token: params.token, materialToken: item.token }))}
					>
						<Delete fontSize='small' />
					</IconButton>
				)
			}
			case 'optionContainer': {
				return (
					<IconButton
						size='small'
						onClick={() => dispatch(deleteContainer({ token: params.token, materialToken: item.token }))}
					>
						<Delete fontSize='small' />
					</IconButton>
				)
			}
			case 'typeContainer': {
				const { typeContainer } = item
				return containerOptions.filter((x) => x.value === typeContainer)[0]
					? containerOptions.filter((x) => x.value === typeContainer)[0].label
					: ''
			}
			default:
				return ''
		}
	}

	if (isLoading) return <LoadingPage />
	let canBeUpdateInformationInternational = canBeEditInternalUserData || canbeUpdateSupplierInternational
	let canBeUpdateInformationNacional = canBeEditInternalUserData || canbeUpdateSupplierNacional
	let canBeUpdateInformationPreviousOrigin = canBeEditInternalUserData || canbeUpdateSupplierPreviousOrigin

	return (
		<Paper style={{ padding: '10px' }}>
			<HeaderComponent
				//object props section
				loadAlert={loadAlert}
				//bool
				supplierLogo={supplierLogo}
				urlImageSupplier={urlImageSupplier}
				supplier={supplier}
				yourlogohere={yourlogohere}
			/>
			<Divider />
			{
				<List>
					<GeneralData
						//object props section
						loadAlert={loadAlert}
						//functions props section
						onUpdateRequest={onUpdateRequest}
						addPreviousOriging={addPreviousOriging}
						canBeEditData={canBeUpdateInformationInternational}
					/>
					<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
						<div style={{ display: 'flex', gap: '15px' }}>
							{(canbeUpdateSupplierInternational || canBeEditInternalUserData) && (
								<Chip
									label={<Translate id='loadAlerts.foreignSuppluier' />}
									style={{ borderRadius: 0, width: '300px', height: '45px', gap: '10px' }}
									color={tab === '1' ? 'primary' : 'inherit'}
									icon={<Public />}
									onClick={() => setTab('1')}
								/>
							)}
							{(canbeUpdateSupplierNacional || canBeEditInternalUserData) && (
								<Chip
									label={<Translate id='loadAlerts.nationalSuppluier' />}
									style={{ borderRadius: 0, width: '300px', height: '45px', gap: '10px' }}
									color={tab === '2' ? 'primary' : 'inherit'}
									icon={<Public />}
									onClick={() => setTab('2')}
								/>
							)}
							{previousOriginData && (canbeUpdateSupplierPreviousOrigin || canBeEditInternalUserData) && (
								<Chip
									label={<Translate id='loadAlerts.previousOriginSupplier' />}
									style={{ borderRadius: 0, width: '300px', height: '45px', gap: '10px' }}
									color={tab === '3' ? 'primary' : 'inherit'}
									icon={<Public />}
									onClick={() => setTab('3')}
								/>
							)}
						</div>
					</div>
				</List>
			}
			{/* {tab === '1' && (
				<List>
					<ListItem>
						<ListItemText
							primary={
								<div style={{ display: 'flex', gap: '15px' }}>
									<Flight />
									<Typography component='span' variant='body2' color='textSecondary'>
										<strong>
											{' '}
											<Translate id='loadAlerts.shipment' />
										</strong>
									</Typography>
								</div>
							}
						/>
					</ListItem>
				</List>
			)} */}
			{(canbeUpdateSupplierInternational || canBeEditInternalUserData) && (
				<InternationalComponent
					//string props section
					tabSelected={tab}
					//object props
					internacionalData={internacionalData}
					//functions
					updateLoadAlertItemProperty={updateLoadAlertItemProperty}
					onSendNotificationToSupplier={onSendNotificationToSupplier}
					onLateralPanelConfig={onLateralPanelConfig}
					deleteAnnexesFiles={deleteAnnexesFiles}
					//Array
					userRolesByCompany={userRolesByCompany}
					//Bool props section
					canBeEditData={canBeUpdateInformationInternational}
					canBeEditInternalUserData={canBeEditInternalUserData}
				/>
			)}

			{(canbeUpdateSupplierNacional || canBeEditInternalUserData) && (
				<NationalComponent
					//string props section
					tabSelected={tab}
					//object props
					nacionalData={nacionalData}
					//functions
					updateLoadAlertItemProperty={updateLoadAlertItemProperty}
					onSendNotificationToSupplier={onSendNotificationToSupplier}
					onLateralPanelConfig={onLateralPanelConfig}
					//bool props section
					canBeEditData={canBeUpdateInformationNacional}
					canBeEditInternalUserData={canBeEditInternalUserData}
				/>
			)}

			{(canbeUpdateSupplierPreviousOrigin || canBeEditInternalUserData) && (
				<PreviousOriginComponent
					//string props section
					tabSelected={tab}
					//object props
					previousOriginData={previousOriginData}
					//functions
					updateLoadAlertItemProperty={updateLoadAlertItemProperty}
					onSendNotificationToSupplier={onSendNotificationToSupplier}
					onLateralPanelConfig={onLateralPanelConfig}
					//bool props section
					canBeEditData={canBeUpdateInformationPreviousOrigin}
					canBeEditInternalUserData={canBeEditInternalUserData}
				/>
			)}
			<List>
				<ListItem>
					<ListItemText
						primary={
							<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
								<div style={{ display: 'flex', gap: '10px' }}>
									<AddBox />
									<Typography
										component='span'
										variant='body2'
										color='textSecondary'
										style={{ whiteSpace: 'nowrap' }}
									>
										<strong>
											{' '}
											<Translate id='loadAlerts.containersBoxes' />
										</strong>
									</Typography>
								</div>
								<Button onClick={() => onLateralPanelConfig('AddLoadAlert')}>
									<Typography component='span' variant='body2' style={{ marginRight: '8px' }}>
										Agregar contenedores
									</Typography>
									<AddCircle style={{ color: '#4377C4' }} />
								</Button>
							</div>
						}
					/>
				</ListItem>
				<DataTable
					data={loadAlert.containers ? loadAlert.containers : []}
					configuration={TableConfiguration()}
					isIndex
					onRenderCellItem={onRendercustomCell}
				/>
			</List>
			<ListDocumentsComponent
				panel='AddInspectionDocument'
				title='loadAlerts.inspectionDocument'
				documents={loadAlert.inspectionDocument}
				onLateralPanelConfig={onLateralPanelConfig}
			/>
			<List>
				<ListItem>
					<ListItemText
						primary={
							<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
								<div style={{ display: 'flex', gap: '15px' }}>
									<AddBox />
									<Typography
										component='span'
										variant='body2'
										color='textSecondary'
										style={{ whiteSpace: 'nowrap' }}
									>
										<strong>
											{' '}
											<Translate id='loadAlerts.material' />
										</strong>
									</Typography>
								</div>
								<Button onClick={() => onLateralPanelConfig('AddMaterial')}>
									<Typography component='span' variant='body2' style={{ marginRight: '8px' }}>
										Agregar material
									</Typography>
									<AddCircle style={{ color: '#4377C4' }} />
								</Button>
							</div>
						}
					/>
				</ListItem>
				<DataTable
					data={loadAlert.materials ? loadAlert.materials : []}
					configuration={TableMaterialConfiguration()}
					isIndex
					onRenderCellItem={onRendercustomCell}
				/>
			</List>
		</Paper>
	)
}
function TableConfiguration() {
	let columns = [
		{
			header: <Translate id='loadAlerts.unitType' />,
			dataSource: 'typeContainer',
			isSortable: true,
		},
		{
			header: <Translate id='loadAlerts.type' />,
			dataSource: 'code',
			isSortable: true,
		},
		{
			header: <Translate id='loadAlerts.quantity' />,
			dataSource: 'quantity',
		},
		{
			header: <Translate id='common.options' />,
			dataSource: 'optionContainer',
		},
	]
	return { columns }
}
function TableMaterialConfiguration() {
	let columns = [
		{
			header: <Translate id='loadAlerts.partNumberCode' />,
			dataSource: 'partNumberCode',
			isSortable: true,
		},
		{
			header: <Translate id='loadAlerts.partNumberDescription' />,
			dataSource: 'partNumberDescription',
			isSortable: true,
		},
		{
			header: <Translate id='loadAlerts.measurementUnit' />,
			dataSource: 'measurementUnit',
			isSortable: true,
		},
		{
			header: <Translate id='loadAlerts.quantity' />,
			dataSource: 'quantity',
		},
		{
			header: <Translate id='common.options' />,
			dataSource: '',
		},
	]
	return { columns }
}

/** Resources import section */
const useStyle = (theme) => ({})

export default withRouter(withStyles(useStyle, { withTheme: true })(DesktopView))
